<template>
  <Headline :subtitle="'Künstliche Intelligenz mit .NET'">KI & .NET</Headline>
  <div class="pt-4 md:pt-8 xl:pt-16 pb-32 lg:my-5">
    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mb-8">
      
      <div class="lg:text-center">
        <p class="inline-block p max-w-2xl pb-4 sm:pb-8 md:pb-12 mx-auto"><i>"The real question is not whether machines think but whether men do."</i> ― B.F. Skinner</p>
      </div>

      <div class="lg:flex">
        <div class="lg:w-7/12 lg:pr-32 lg:mt-20">
          <h3 class="h3 title">KI trifft Softwarehandwerk</h3>
          <p>Bei Softwerkstatt verbinden wir die Leistung moderner KI-Technologien mit der Stabilität und Zuverlässigkeit des .NET Ökosystems. Wir entwickeln intelligente Lösungen, die Ihr Business transformieren und Ihre Prozesse optimieren.</p>
          <ul class="checklist darkblue mb-4 2xl:mb-8" style="color: #214979;">
            <li>Machine Learning und Deep Learning Integration</li>
            <li>Sichere und skalierbare KI-Lösungen</li>
            <li>KI-gestützte Geschäftsprozessoptimierung</li>
          </ul>
        </div>
        <div class="lg:w-5/12">
          <!-- <img src="./../assets/img/intro/innovation.webp" alt="KI & .NET Entwicklung" /> -->
        </div>
      </div>
    </div>

    <Container>
      <h3 class="h1">Softwerkstatt <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="52" class="inline-block -mt-4 opacity-90 text-[#0291D8]"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> Intelligenz</h3>
      <p class="px-4 sm:px-0 mb-4 sm:mb-12 w-full md:max-w-4xl mx-auto text-left sm:text-center">Die Kombination von künstlicher Intelligenz und .NET eröffnet neue Möglichkeiten für Enterprise-Lösungen. Mit modernen KI-Frameworks und der Robustheit von .NET bauen wir die intelligenten Systeme von morgen.
      </p>
    </Container>

    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mt-16">
      <h2 class="h1">Unsere Expertise</h2>
      <p>Unser Team bringt jahrelange Erfahrung in der Softwareentwicklung mit modernem KI-Wissen zusammen. Wir verstehen sowohl die technischen Anforderungen von Large Language Models und Neural Networks als auch die praktischen Anforderungen für produktive Systeme.</p>
      <div class="flex">
        <div class="w-2/3 z-10 mr-8 border border-gray-200 rounded-md shadow-sm bg-white">
          <!-- <img class="rounded-lg" src="./../assets/img/intro/innovation.webp" alt="KI und .NET Technologien" /> -->
        </div>
        <div class="w-1/3 border border-gray-200 rounded-md shadow-sm bg-white z-10 px-2 md:px-4 lg:px-6 pt-4 lg:pt-8 ">
          <div class="-mx-6 px-6 pb-4 border-b-2" style="border-color: #428BB0">
            <img src="./../assets/img/icons/werkzeug.svg" alt="" class="w-12 inline-block mr-6 -mt-4" />
            <h3 class="h3 inline-block" style="color: #214A7B;">Über KI & .NET</h3>
          </div>
          <p>.NET bietet durch Azure AI Services und die Integration von OpenAI, TensorFlow und anderen Frameworks optimale Voraussetzungen für KI-Projekte. Wir nutzen diese Möglichkeiten, um intelligente und sichere Lösungen zu schaffen.</p>
        </div>
      </div>
    </div>

    <Container class="-mt-28 sm:-mt-28 mb-4 sm:mb-8 2xl:mb-16" :styles="'py-6 sm:pb-8 pt-28 sm:pt-32 md:pt-36 lg:pt-48 px-4 lg:px-0'">
      <h2 class="h1">Was wir umsetzen</h2>
      <p class="max-w-5xl">Mit KI & .NET realisieren wir intelligente Unternehmensanwendungen, die Ihre Daten nutzen und Ihre Prozesse automatisieren. Von der Machbarkeitsstudie bis zur produktiven Lösung begleiten wir Sie auf dem Weg zur KI-gestützten Transformation.</p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-16 text-left mb-8">
        <div class="col-span-1 bg-white border border-gray-200 shadow-sm rounded-md p-2 lg:p-6 lg:pt-8">
          <div class="-mx-6 px-6 pb-4 border-b-2" style="border-color: #428BB0">
            <img src="./../assets/img/icons/konzept.svg" alt="" class="w-12 inline-block mr-6 -mt-4" />
            <h3 class="h3 inline-block" style="color: #214A7B;">Unsere Leistungen</h3>
          </div>
          <ul class="list">
            <li>KI-Strategie und Machbarkeitsstudien</li>
            <li>Integration von Large Language Models</li>
            <li>Machine Learning Model Development</li>
            <li>KI-Sicherheit und Compliance</li>
          </ul>
        </div>
        <div class="col-span-1 bg-white border border-gray-200 shadow-sm rounded-md p-2 lg:p-6 lg:pt-8">
          <div class="-mx-6 px-6 pb-4 border-b-2" style="border-color: #428BB0">
            <img src="./../assets/img/icons/code.svg" alt="" class="w-12 inline-block mr-6 -mt-4" />
            <h3 class="h3 inline-block" style="color: #214A7B;">Unsere Umsetzung</h3>
          </div>
          <ul class="list">
            <li>Azure OpenAI Service Integration</li>
            <li>LLM-basierte Chatbots und Assistenten</li>
            <li>Predictive Analytics & Datenanalyse</li>
            <li>Production-ready KI-Systeme</li>
          </ul>
        </div>
      </div>
    </Container>

    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0">
      <ContactInfos />
    </div>
    
  </div>
</template>

<script>
import Headline from '../views/Headline.vue'
import ContactInfos from './../views/ContactInfos.vue'
import Container from './../views/Container.vue'

export default {
  name: 'KiDotNet',
  components: {
    Headline,
    ContactInfos,
    Container
  }
}
</script>

<style scoped>
</style>
